'use client'
import { VerifiedCredentialNameToChainEnum } from '../../constants/values.js';

const findWalletOptionFor = (account, walletOptions) => {
    var _a;
    const walletKey = account.walletName;
    if (walletKey === 'turnkeyhd') {
        const chain = account.chain
            ? VerifiedCredentialNameToChainEnum[account.chain]
            : undefined;
        return walletOptions.find((wallet) => walletKey === wallet.key &&
            wallet.walletConnector.connectedChain === chain);
    }
    // if we cannot find the correct connector for the wallet, we default to the unknown
    // this way the wallet will appear in user wallets, but will not be able to be interacted with
    return ((_a = walletOptions.find((wallet) => walletKey === wallet.key)) !== null && _a !== void 0 ? _a : walletOptions.find((wallet) => wallet.key === 'fallbackconnector'));
};

export { findWalletOptionFor };
